import { useEffect, useRef, useState } from "react";
import { MFButton } from "../../../../common/components/MFButton";
import MFModal from "../../../../common/containers/MFModal";
import { AlertCircle } from "../../../../assets/icons/AlertCircle";

export function ModalRenameCalcul({
  isOpen,
  onClose,
  calcul,
  updateCalculAttributes,
  isFinished,
}) {
  const [title, setTitle] = useState("");
  const inputRef = useRef();

  useEffect(() => {
    if (calcul) {
      setTitle(calcul.title || "");
    }
  }, [calcul]);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const handleSave = async () => {
    updateCalculAttributes(calcul._id, { title });
    onClose();
  };

  return (
    <MFModal
      isOpen={isOpen}
      onClose={onClose}
      dialogClassName="folder-modal-container"
    >
      <p className="modal-title text-center">Renommer le calcul</p>
      <form onSubmit={(e) => e.preventDefault()}>
        <div>
          <label htmlFor="label">Nom du calcul</label>
          <input
            id="label"
            placeholder="Test n°1"
            className="form-control"
            onChange={(e) => setTitle(e.target.value)}
            value={title}
            ref={inputRef}
          />
        </div>
        {isFinished && (
          <div className="error-div" style={{ marginTop: 24 }}>
            <div className="error-logo">
              <AlertCircle size={22} />
            </div>
            Attention : si vous avez déjà généré un export définitif pour ce
            calcul, et que le nom du calcul apparait dans l’export, le fait de
            renommer votre calcul ne mettra pas à jour cet export.
          </div>
        )}
        <div className="d-flex align-items-center justify-content-center mt-4">
          <MFButton
            style={{ fontSize: 15 }}
            className="mr-1"
            onClick={handleSave}
            disabled={title === ""}
          >
            Valider
          </MFButton>
          <MFButton style={{ fontSize: 15 }} cancelButton onClick={onClose}>
            Annuler
          </MFButton>
        </div>
      </form>
    </MFModal>
  );
}
